import { HTTPService } from "../../core/util/httpManager.js";
import React from "react";
export default class Multiselect extends React.Component<MultiselectProps, {items: Item[]}>{
    private multiSelectRef: any;
    private multiSelect: kendo.ui.MultiSelect;
    private dataSource: Item[];


    constructor(props: MultiselectProps) {
        super(props);
        this.state = {
            items: []
        }
    }

    private build = () => {
        this.multiSelect = $(this.multiSelectRef).kendoMultiSelect({
            value: this.state.items,
            enable: true,
            dataSource: this.dataSource,
            itemTemplate: "<div>#=data.Name#</div>",
            tagTemplate: "<div>#=data.Name#</div>",
            dataTextField: 'Name',
            dataValueField: 'Value',
            clearButton: true,
            change: (ev) => {
                const keys = ev.sender.value().map((x) => { return parseInt(x) });
                this.props.onChange(this.props.field, keys, ev.sender.value())
            }
        }).data("kendoMultiSelect");


    }

    private loadDataSource = async () => {
        const result = await HTTPService.get(this.props.field.dataSourceUrl);
        this.dataSource = result;
        const vals = this.dataSource.filter((item) => {
            return this.props.value.findIndex(v => v.toString() === item.Value) > -1;
        })
        this.setState({ items: vals }, this.build)
    }

    componentDidMount() {
        this.loadDataSource();
    }

    render() {
        let style: React.CSSProperties = {
            width: "100%"
        };
        return (
            <div>
                <select ref={(r) => this.multiSelectRef = r} style={style} />
            </div>
        );
    }
}

interface MultiselectProps{
    value: number[];
    field: {
        dataSourceUrl: string;
    };
    onChange: (field: any, value: any, dataItem) => void;
}

interface Item {
    Value, Name
}